import PIPELINE_STEPS from '../../../../utils/pipeline_steps';
import ColumnActionModel from './column_action_model';
import TableModel from "../../../datasource/table";

export const SORT_ASC = 'ascending';
export const SORT_DESC = 'descending';

export default class SortColumnStepModel extends ColumnActionModel {
    name = 'Sort Column';
    type = PIPELINE_STEPS.SORT_COLUMN;
    direction = null;  // null means no direction

    constructor({direction, ...otherProps}) {
        super(otherProps);
        this.direction = direction || null;
        this.isSaved = !!this.direction;
    }

    setSort(direction) {
        this.direction = direction;
        this.isSaved = true;
    }

    isAscending() {
        return this.direction === SORT_ASC;
    }

    isDescending() {
        return this.direction === SORT_DESC;
    }

    apply(table) {
        if (this.direction === null) {
            return {table, incomplete: true};
        }

        const newTable = new TableModel(table);
        const column = newTable.getColumnById(this.columnId);
        if (column) {
            SortColumnStepModel.sort(newTable, column, this.direction === SORT_DESC);
            return {table: newTable};
        }
        return {table, error: true};
    }

    static sort(table, column, reverse = false) {
        let sampleData = column.sample.slice().map((value, i) => ({originalIndex: i, value}));
        switch (column.type) {
            case 'number':
                sampleData.sort((a, b) => a.value - b.value);
                break;
            default:
                sampleData.sort((a, b) => a.value > b.value ? 1 : (a.value === b.value ? 0 : -1));
                break;
        }
        if (reverse) {
            sampleData = sampleData.reverse();
        }
        for (const otherColumn of table.columns) {
            if (otherColumn !== column) {
                const otherSampleData = otherColumn.sample.slice();
                otherColumn.sample = sampleData.map(({originalIndex}) => otherSampleData[originalIndex]);
            }
        }
        column.sample = sampleData.map(({value}) => value);
    }
}
